var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80005 4.50001C1.80005 3.5059 2.60594 2.70001 3.60005 2.70001H9.90005C10.8942 2.70001 11.7 3.5059 11.7 4.50001V8.10001C11.7 9.09412 10.8942 9.90001 9.90005 9.90001H8.10005L5.40005 12.6V9.90001H3.60005C2.60594 9.90001 1.80005 9.09412 1.80005 8.10001V4.50001Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.30001V7.70001C13.5 9.90915 11.7092 11.7 9.50005 11.7H8.84563L7.2556 13.29C7.50743 13.4241 7.79487 13.5 8.10005 13.5H9.90005L12.6 16.2V13.5H14.4C15.3942 13.5 16.2 12.6941 16.2 11.7V8.10001C16.2 7.1059 15.3942 6.30001 14.4 6.30001H13.5Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.57bb59403c5671abc2fb858cfe325dfd.svg";
export { ForwardRef as ReactComponent };